import React, { useEffect, useRef } from 'react'

import styles from './intersection-point.module.css'

const options = {
  rootMargin: '0px 0px 0px 0px',
  threshold: 1.0
}

export const IntersectionPoint = ({ setIsVisible: setIsIntersecting }) => {
  const componentRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries
      setIsIntersecting(entry.isIntersecting)
    }, options)

    if (componentRef.current) {
      observer.observe(componentRef.current)
    }

    return () => {
      return observer.disconnect()
    }
  }, [componentRef, setIsIntersecting])

  return <div ref={componentRef} className={styles.intersectionPoint} />
}
